import Chip from '@mui/material/Chip';

const chipColors = score => {
  if (score > 89) {
    return 'success';
  } else if (score > 49) {
    return 'info';
  } else {
    return 'error';
  }
};

const PercentDeliveredChip = ({ score }) => {
  const percentage = parseFloat((score * 100).toFixed(0));
  return (
    <Chip
      label={`${percentage}%`}
      color={chipColors(percentage)}
      size="small"
    />
  );
};

export default PercentDeliveredChip;
